import { render, staticRenderFns } from "./Debt.vue?vue&type=template&id=b7ff6d28&"
import script from "./Debt.vue?vue&type=script&lang=ts&"
export * from "./Debt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports